<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="3">
        <b-form-group
          :label="$t('checklist.template.templateName')"
          label-for="label-template-name"
          class="mb-4"
        >
          <b-form-input
            id="input-template-name"
            type="text"
            v-model="model.templateName"
            required
            placeholder="Insira o nome do processo"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12" md="3">
        <b-form-group
          v-if="model.formId != 0 && editing"
          label="Formulário"
          label-for="label-template-name"
          class="mb-4"
        >
          <b-form-input
            id="input-template-name"
            type="text"
            v-model="selectedFormModel"
            :readonly="true"
          >
          </b-form-input>
        </b-form-group>
        <b-table
          v-else
          sticky-header="500px"
          hover
          :items="forms"
          :fields="formField"
          selectable
          select-mode="single"
          @row-selected="onChange"
        >
        </b-table>
      </b-col>
      <b-col v-if="selectedForm">
        <b-table
          sticky-header="500px"
          hover
          :items="availableFields"
          :fields="availabelFieldLabel"
          selectable
          select-mode="single"
          @row-selected="onSelectAvailable"
        >
        </b-table>
        <!-- {{ sortedFormFields }} -->
        <!-- <pre class="language-json"><code>Fields: {{ formFields  }}</code></pre> -->
      </b-col>
      <b-col v-if="selectedForm">
        <!-- {{ sortedFormFieldsSelected }} -->
        <!-- <pre class="language-json"><code>Model: {{ sortedFormFieldsSelected  }}</code></pre> -->
        <b-table
          sticky-header="500px"
          hover
          :items="sortedFormFieldsSelected"
          :fields="selectedFieldsLabel"
          selectable
          select-mode="single"
          @row-selected="onSelectAdded"
        >
        </b-table>
      </b-col>
    </b-row>
    <!-- {{ formFields }} -->
    <!-- <pre class="language-json"><code>Model: {{ formFields  }}</code></pre> -->
    <!-- <pre class="language-json"><code>Model: {{ model  }}</code></pre> -->
  </b-container>
</template>
<script>
export default {
  name: "ExportTemplateCsvCrud",
  props: {
    model: Object,
    modelstate: Object,
    editing: Boolean,
  },
  components: {
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
  },
  data() {
    return {
      forms: [],
      form: "",
      formFields: [],
      selectedForm: false,
      formId: 0,
      availabelFieldLabel: [
        {
          label: this.$t("geral.availableFields"),
          key: "fieldName",
          sortable: true,
        },
      ],
      selectedFieldsLabel: [
        {
          label: "Campos secionados",
          key: "fieldName",
          sortable: true,
        },
      ],
      formField: [
        {
          label: "Id",
          key: "value",
          sortable: true,
        },
        {
          label: "Formulario",
          key: "text",
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.getAllForms();
  },
  computed: {
    selectedFormModel() {
      if (this.model.formId != 0) {
        this.forms.forEach((form) => {
          if (form.value == this.model.formId) {
            this.form = form.text;
            this.selectedForm = true;
          }
        });
        this.getAllFormFields();
      }
      return this.form;
    },
    availableFields() {
      let fields = [];
      let selectedFields = this.model.fields;
      this.sortedFormFields.forEach((field) => {
        // console.log()
        if (
          !selectedFields.some((e) => e.sequenceNumber == field.sequenceNumber)
        ) {
          fields.push(field);
        }
      });
      return fields;
    },
    sortedFormFieldsSelected() {
      let formFieldsSelected = [];
      for (let formField of this.sortedFormFields) {
        // console.log(formField)
        let field = this.model.fields.find(
          (e) => e.fieldName == formField.fieldName
        );
        // console.log(field);
        if (field) {
          formFieldsSelected.push(field);
        }
      }
      return formFieldsSelected;
    },
    sortedFormFields() {
      let fields = [];
      this.formFields.forEach((field) => {
        if (field.active) {
          fields.push(field);
        }
      });
      return fields;
    },
  },
  methods: {
    getAllForms() {
      this.$apiChecklist
        .get("/exportTemplateCsv/getAllForms/")
        .then((response) => {
          this.forms = response.data;
        });
    },
    getAllFormFields() {
      this.$apiChecklist
        .get("/exportTemplateCsv/getAllFormFields/" + this.model.formId)
        .then((response) => {
          this.formFields = response.data;
          this.$forceUpdate();
        });
    },
    onChange(value) {
      if (value.length != 0) {
        value.forEach((v) => {
          this.model.formId = v.value;
        });
        this.selectedForm = true;
        this.getAllFormFields();
      } else {
        this.model.formId = 0;
      }
    },
    onSelectAvailable(items) {
      for (let item of items) {
        this.model.fields.push(item);
      }
    },
    onSelectAdded(items) {
      for (let item of items) {
        let selectedIndex = this.model.fields.indexOf(item);
        if (selectedIndex >= 0) {
          this.model.fields.splice(selectedIndex, 1);
        }
      }
    },
  },
  watch: {
    model() {
      if (this.model.formId != 0) {
        this.selectedForm = true;
      }
    },
  },
};
</script>